import React, { useEffect, useState } from 'react';
import { X, Send, ChevronRight, ChevronLeft } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../api';
import { mensajeErrorApi } from '../apiErrors';

const PASOS = ['Contacto', 'Origen USA', 'Paquete', 'Contenido', 'Entrega USA', 'Destino EC', 'Confirmación'];

const PRODUCTOS_ESPECIALES = [
  { value: 'electronicos', label: 'Electrónicos' },
  { value: 'baterias', label: 'Baterías' },
  { value: 'liquidos', label: 'Líquidos' },
  { value: 'cosmeticos', label: 'Cosméticos o perfumes' },
  { value: 'medicinas', label: 'Medicinas o suplementos' },
  { value: 'alimentos', label: 'Alimentos' },
  { value: 'repuestos', label: 'Repuestos' },
];

const PROVINCIAS_EC = [
  'Azuay', 'Bolívar', 'Cañar', 'Carchi', 'Chimborazo', 'Cotopaxi', 'El Oro',
  'Esmeraldas', 'Galápagos', 'Guayas', 'Imbabura', 'Loja', 'Los Ríos',
  'Manabí', 'Morona Santiago', 'Napo', 'Orellana', 'Pastaza', 'Pichincha',
  'Santa Elena', 'Santo Domingo de los Tsáchilas', 'Sucumbíos', 'Tungurahua', 'Zamora Chinchipe',
];

const CONFIRMACIONES = [
  'Confirmo que el peso, medidas, contenido y valor declarado ingresados servirán como base para la cotización.',
  'Entiendo que diferencias de peso, medidas, dirección incorrecta, paquete no listo o recolección fallida pueden generar cargos adicionales a cargo del cliente.',
  'Entiendo que algunos productos pueden estar restringidos o requerir revisión adicional para ingresar a Ecuador.',
  'Entiendo que la cotización no es inmediata y será enviada por WhatsApp o correo luego de revisar mi solicitud.',
];

function vacio() {
  return {
    nombre_completo: '', email: '', whatsapp: '', ubicacion_actual: 'usa',
    ciudad_origen: '', estado_usa: '', zip_code: '', paquete_listo: 'si',
    peso_lb: '', largo: '', ancho: '', alto: '', num_paquetes: 1,
    contenido_descripcion: '', valor_declarado: '', condicion: 'nuevo', productos_especiales: [],
    entrega_preferencia: 'domicilio', direccion_retiro_usa: '',
    ciudad_destino_ec: '', provincia_ec: '', entrega_domicilio_ec: 'si', direccion_entrega_ec: '',
  };
}

export default function SolicitarPuertaPuertaModal({ onClose, onCreada }) {
  const [paso, setPaso] = useState(0);
  const [datos, setDatos] = useState(vacio());
  const [foto, setFoto] = useState(null);
  const [confirmaciones, setConfirmaciones] = useState([false, false, false, false]);
  const [enviando, setEnviando] = useState(false);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    api.get('/mi-perfil/').then((res) => {
      const c = res.data?.cliente;
      if (c) {
        setDatos((d) => ({
          ...d,
          nombre_completo: [c.user?.first_name, c.user?.last_name].filter(Boolean).join(' '),
          email: c.user?.email || '',
          whatsapp: c.whatsapp || '',
        }));
      }
    }).catch(() => {}).finally(() => setCargando(false));
  }, []);

  const set = (campo, valor) => setDatos((d) => ({ ...d, [campo]: valor }));

  const toggleProducto = (valor) => {
    setDatos((d) => ({
      ...d,
      productos_especiales: d.productos_especiales.includes(valor)
        ? d.productos_especiales.filter((v) => v !== valor)
        : [...d.productos_especiales, valor],
    }));
  };

  const validarPaso = () => {
    switch (paso) {
      case 0:
        if (!datos.nombre_completo.trim() || !datos.email.trim() || !datos.whatsapp.trim()) {
          toast.error('Completa nombre, correo y WhatsApp.');
          return false;
        }
        return true;
      case 1:
        if (!datos.ciudad_origen.trim() || !datos.estado_usa.trim() || !datos.zip_code.trim()) {
          toast.error('Completa la ciudad, estado y ZIP code de origen.');
          return false;
        }
        return true;
      case 2:
        if (!datos.peso_lb || !datos.largo || !datos.ancho || !datos.alto) {
          toast.error('Completa el peso y las medidas del paquete.');
          return false;
        }
        return true;
      case 3:
        if (!datos.contenido_descripcion.trim() || !datos.valor_declarado || !datos.condicion) {
          toast.error('Completa el contenido, valor declarado y condición.');
          return false;
        }
        return true;
      case 4:
        if (!datos.entrega_preferencia) {
          toast.error('Indica cómo prefieres entregar el paquete en USA.');
          return false;
        }
        return true;
      case 5:
        if (!datos.ciudad_destino_ec.trim() || !datos.provincia_ec) {
          toast.error('Completa la ciudad y provincia de entrega en Ecuador.');
          return false;
        }
        return true;
      default:
        return true;
    }
  };

  const siguiente = () => { if (validarPaso()) setPaso((p) => Math.min(p + 1, PASOS.length - 1)); };
  const anterior = () => setPaso((p) => Math.max(p - 1, 0));

  const enviar = async () => {
    if (confirmaciones.some((c) => !c)) {
      toast.error('Debes aceptar las 4 confirmaciones.');
      return;
    }
    setEnviando(true);
    try {
      const form = new FormData();
      Object.entries(datos).forEach(([k, v]) => {
        if (k === 'productos_especiales') {
          form.append(k, JSON.stringify(v));
        } else if (v !== '' && v !== null) {
          form.append(k, v);
        }
      });
      form.append('terminos_aceptados', true);
      if (foto) form.append('foto', foto);

      const res = await api.post('/puerta-a-puerta/', form, { headers: { 'Content-Type': 'multipart/form-data' } });
      toast.success('Solicitud enviada — te contactaremos con la cotización.');
      onCreada(res.data);
    } catch (err) {
      toast.error(mensajeErrorApi(err, 'No se pudo enviar la solicitud.'));
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '640px', maxHeight: '90vh', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3>Solicita tu cotización USA–Ecuador</h3>
          <button className="btn-ghost" onClick={onClose}><X size={18} /></button>
        </div>
        <p className="text-sm text-secondary" style={{ marginTop: '2px' }}>
          Completa los datos del paquete para que revisemos la mejor opción y te enviemos una cotización personalizada por WhatsApp o correo.
        </p>

        <div style={{ display: 'flex', justifyContent: 'space-between', margin: 'var(--spacing-4) 0', flexWrap: 'wrap', gap: '4px' }}>
          {PASOS.map((label, i) => (
            <div key={label} style={{ textAlign: 'center', flex: 1, minWidth: '70px' }}>
              <div style={{
                width: '26px', height: '26px', borderRadius: '50%', margin: '0 auto 4px',
                display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 700,
                background: i < paso ? 'var(--color-primary)' : i === paso ? '#fff' : '#fff',
                color: i < paso ? '#111' : i === paso ? 'var(--color-primary)' : 'var(--color-text-secondary)',
                border: i === paso ? '2px solid var(--color-primary)' : i < paso ? 'none' : '1px solid var(--color-border)',
              }}>
                {i + 1}
              </div>
              <span className="text-xs" style={{ color: i === paso ? 'var(--color-primary)' : 'var(--color-text-secondary)', fontWeight: i === paso ? 700 : 400 }}>
                {label}
              </span>
            </div>
          ))}
        </div>

        {cargando ? <p className="text-secondary">Cargando...</p> : (
          <div className="form-stack">
            {paso === 0 && (
              <>
                <div>
                  <label>Nombre completo *</label>
                  <input value={datos.nombre_completo} onChange={(e) => set('nombre_completo', e.target.value)} placeholder="Nombre y apellido" />
                </div>
                <div className="form-row">
                  <div>
                    <label>Email *</label>
                    <input type="email" value={datos.email} onChange={(e) => set('email', e.target.value)} placeholder="tuemail@correo.com" />
                  </div>
                  <div>
                    <label>WhatsApp *</label>
                    <input value={datos.whatsapp} onChange={(e) => set('whatsapp', e.target.value)} placeholder="+1 786 000 0000" />
                  </div>
                </div>
                <div>
                  <label>¿Dónde te encuentras actualmente? *</label>
                  <select value={datos.ubicacion_actual} onChange={(e) => set('ubicacion_actual', e.target.value)}>
                    <option value="usa">Estados Unidos</option>
                    <option value="ecuador">Ecuador</option>
                    <option value="otro">Otro</option>
                  </select>
                </div>
              </>
            )}

            {paso === 1 && (
              <>
                <div>
                  <label>Ciudad de origen en Estados Unidos *</label>
                  <input value={datos.ciudad_origen} onChange={(e) => set('ciudad_origen', e.target.value)} placeholder="New York, Houston, Miami, Chicago" />
                </div>
                <div className="form-row">
                  <div>
                    <label>Estado *</label>
                    <input value={datos.estado_usa} onChange={(e) => set('estado_usa', e.target.value)} placeholder="FL, TX, NY..." />
                  </div>
                  <div>
                    <label>ZIP Code *</label>
                    <input value={datos.zip_code} onChange={(e) => set('zip_code', e.target.value)} />
                  </div>
                </div>
                <div>
                  <label>¿El paquete ya está listo para enviar? *</label>
                  <select value={datos.paquete_listo} onChange={(e) => set('paquete_listo', e.target.value)}>
                    <option value="si">Sí, ya está cerrado y listo</option>
                    <option value="no">No, todavía lo estoy empacando</option>
                  </select>
                </div>
              </>
            )}

            {paso === 2 && (
              <>
                <div>
                  <label>Peso aproximado del paquete en libras *</label>
                  <input type="number" step="0.01" min="0" value={datos.peso_lb} onChange={(e) => set('peso_lb', e.target.value)} placeholder="10" />
                </div>
                <div className="form-row">
                  <div>
                    <label>Largo (in) *</label>
                    <input type="number" step="0.01" min="0" value={datos.largo} onChange={(e) => set('largo', e.target.value)} placeholder="18" />
                  </div>
                  <div>
                    <label>Ancho (in) *</label>
                    <input type="number" step="0.01" min="0" value={datos.ancho} onChange={(e) => set('ancho', e.target.value)} placeholder="12" />
                  </div>
                  <div>
                    <label>Alto (in) *</label>
                    <input type="number" step="0.01" min="0" value={datos.alto} onChange={(e) => set('alto', e.target.value)} placeholder="10" />
                  </div>
                </div>
                <div className="form-row">
                  <div>
                    <label>¿Cuántos paquetes deseas enviar? *</label>
                    <input type="number" min="1" value={datos.num_paquetes} onChange={(e) => set('num_paquetes', e.target.value)} />
                  </div>
                  <div>
                    <label>Foto del paquete</label>
                    <input type="file" accept="image/*" onChange={(e) => setFoto(e.target.files?.[0] || null)} />
                  </div>
                </div>
              </>
            )}

            {paso === 3 && (
              <>
                <div>
                  <label>¿Qué contiene el paquete? *</label>
                  <textarea rows={3} value={datos.contenido_descripcion} onChange={(e) => set('contenido_descripcion', e.target.value)}
                    placeholder="Ejemplo: ropa, zapatos, juguetes, documentos, regalos o accesorios." />
                </div>
                <div>
                  <label>Valor aproximado del contenido en USD *</label>
                  <input type="number" step="0.01" min="0" value={datos.valor_declarado} onChange={(e) => set('valor_declarado', e.target.value)} placeholder="150" />
                </div>
                <div>
                  <label>¿El contenido es nuevo, usado o mixto? *</label>
                  <select value={datos.condicion} onChange={(e) => set('condicion', e.target.value)}>
                    <option value="">Escoge una opción</option>
                    <option value="nuevo">Nuevo</option>
                    <option value="usado">Usado</option>
                    <option value="mixto">Mixto</option>
                  </select>
                </div>
                <div>
                  <label>¿El paquete contiene alguno de estos productos?</label>
                  <div style={{ display: 'grid', gap: '4px' }}>
                    {PRODUCTOS_ESPECIALES.map((p) => (
                      <label key={p.value} style={{ display: 'flex', alignItems: 'center', gap: '6px', fontWeight: 400 }}>
                        <input type="checkbox" checked={datos.productos_especiales.includes(p.value)} onChange={() => toggleProducto(p.value)} />
                        {p.label}
                      </label>
                    ))}
                    <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontWeight: 400 }}>
                      <input type="checkbox" checked={datos.productos_especiales.length === 0} readOnly disabled />
                      Ninguno de los anteriores
                    </label>
                  </div>
                </div>
              </>
            )}

            {paso === 4 && (
              <>
                <div>
                  <label>¿Cómo prefieres entregar el paquete en Estados Unidos? *</label>
                  <select value={datos.entrega_preferencia} onChange={(e) => set('entrega_preferencia', e.target.value)}>
                    <option value="domicilio">Retiro a domicilio (Ecuafly coordina el pickup)</option>
                    <option value="punto_ups">Yo lo entrego en un punto UPS</option>
                  </select>
                </div>
                <div>
                  <label>Dirección de retiro en USA, si aplica</label>
                  <textarea rows={3} value={datos.direccion_retiro_usa} onChange={(e) => set('direccion_retiro_usa', e.target.value)}
                    placeholder="Completa solo si deseas retiro en domicilio. Incluye calle, ciudad, estado y ZIP Code." />
                </div>
              </>
            )}

            {paso === 5 && (
              <>
                <div className="form-row">
                  <div>
                    <label>Ciudad de entrega en Ecuador *</label>
                    <input value={datos.ciudad_destino_ec} onChange={(e) => set('ciudad_destino_ec', e.target.value)} />
                  </div>
                  <div>
                    <label>Provincia *</label>
                    <select value={datos.provincia_ec} onChange={(e) => set('provincia_ec', e.target.value)}>
                      <option value="">Selecciona una opción</option>
                      {PROVINCIAS_EC.map((p) => <option key={p} value={p}>{p}</option>)}
                    </select>
                  </div>
                </div>
                <div>
                  <label>¿Deseas entrega a domicilio en Ecuador? *</label>
                  <select value={datos.entrega_domicilio_ec} onChange={(e) => set('entrega_domicilio_ec', e.target.value)}>
                    <option value="si">Sí</option>
                    <option value="no">No, retiro en oficina</option>
                  </select>
                </div>
                <div>
                  <label>Dirección de entrega en Ecuador, si ya la tienes definida</label>
                  <textarea rows={3} value={datos.direccion_entrega_ec} onChange={(e) => set('direccion_entrega_ec', e.target.value)}
                    placeholder="Puedes colocar sector, ciudadela o referencia. La dirección exacta se confirmará después." />
                </div>
              </>
            )}

            {paso === 6 && (
              <div style={{ display: 'grid', gap: '10px' }}>
                {CONFIRMACIONES.map((texto, i) => (
                  <label key={i} style={{ display: 'flex', gap: '8px', alignItems: 'flex-start', fontWeight: 400 }}>
                    <input
                      type="checkbox" style={{ marginTop: '3px' }}
                      checked={confirmaciones[i]}
                      onChange={() => setConfirmaciones((prev) => prev.map((v, idx) => (idx === i ? !v : v)))}
                    />
                    <span className="text-sm">{texto}</span>
                  </label>
                ))}
              </div>
            )}

            <div className="modal-actions" style={{ justifyContent: 'space-between' }}>
              <button type="button" className="btn-secondary" onClick={paso === 0 ? onClose : anterior}>
                <ChevronLeft size={16} /> {paso === 0 ? 'Cancelar' : 'Anterior'}
              </button>
              {paso < PASOS.length - 1 ? (
                <button type="button" className="btn-primary" onClick={siguiente}>
                  Siguiente <ChevronRight size={16} />
                </button>
              ) : (
                <button type="button" className="btn-primary" disabled={enviando} onClick={enviar}>
                  <Send size={16} /> {enviando ? 'Enviando...' : 'Enviar solicitud de cotización'}
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
